import { useGetItemsQuery } from "@/services/apiSlice/utilitySlice";
import { useMemo } from "react";
import { toast } from "sonner";

export const useSubscriptionToken = () => {
  const { data, error, isLoading, refetch } = useGetItemsQuery(
    "/subscription/token",
    {
      refetchOnMountOrArgChange: true,
      pollingInterval: 900000, // 15 mins
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }
  );

  if (error) {
    toast.error("Something went wrong, while fetching subscription token");
  }

  const subscriptionUrl = useMemo(() => {
    if (data?.result?.token) {
      return `?token=${data?.result?.token}`;
    }

    return null;
  }, [data?.result?.token]);

  return { subscriptionUrl, data, error, isLoading, refetch };
};
